import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';

export default function ConfirmSubmissionModal({ open, onClose, onConfirm, title, body, checkboxLabel }) {
    const [checked, setChecked] = useState(false);

    const handleClose = () => {
        setChecked(false);
        onClose && onClose();
    };

    const handleConfirm = () => {
        onConfirm && onConfirm();
        setChecked(false);
    };

    return (
        <Dialog open={Boolean(open)} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{title || 'Final Submission Confirmation'}</DialogTitle>
            <DialogContent>
                {body ? (
                    Array.isArray(body)
                        ? body.map((text, idx) => <Typography paragraph key={idx}>{text}</Typography>)
                        : <Typography paragraph>{body}</Typography>
                ) : (
                    <>
                        <Typography paragraph>
                            Once you submit this application, it will be final and cannot be edited.
                        </Typography>
                        <Typography paragraph>
                            If you are ready to submit, please check the box below and click Submit.
                        </Typography>
                        <Typography paragraph>
                            If you are not ready, click cancel to return to the form, where you can save it as a draft and make changes later.
                        </Typography>
                    </>
                )}
                <FormControlLabel
                    control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
                    label={checkboxLabel || 'I understand that once submitted, my application cannot be edited.'}
                    sx={{ alignItems: 'flex-start', '.MuiFormControlLabel-label': { mt: '4px' } }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant="contained" color="primary" onClick={handleConfirm} disabled={!checked}>Submit</Button>
            </DialogActions>
        </Dialog>
    );
}
